import { Sparkles, Type } from "lucide-react";

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

import Cartao from "./Cartao";

const Contador = ({ atual, limite }) => (
  <span className={`text-[11px] tabular-nums ${atual > limite ? "text-red-500 font-semibold" : "text-muted-foreground"}`}>{atual}/{limite}</span>
);

/** Passo 2: texto principal, título e botão. A sugestão vem do produto escolhido. */
export default function SecaoTexto({ a }) {
  const { form, definir, limites } = a;
  return (
    <Cartao numero={2} titulo="Texto do anúncio" icone={Type} e2e="impulsionar-texto"
      descricao="Aparece junto da foto. Diga o que é e por que vale a pena pedir agora — sem prometer o que a loja não cumpre.">
      <div className="space-y-4">
        <div>
          <div className="flex items-center justify-between gap-2">
            <Label htmlFor="impulsionar-texto">Texto *</Label>
            <Contador atual={form.texto.length} limite={limites.texto} />
          </div>
          <Textarea id="impulsionar-texto" rows={4} value={form.texto} onChange={(e) => definir("texto", e.target.value)}
            placeholder="Ex.: Hambúrguer artesanal feito na hora. Peça agora pelo nosso cardápio online." className="mt-1" data-e2e="impulsionar-campo-texto" />
        </div>
        <div>
          <div className="flex items-center justify-between gap-2">
            <Label htmlFor="impulsionar-titulo">Título *</Label>
            <Contador atual={form.titulo.length} limite={limites.titulo} />
          </div>
          <Input id="impulsionar-titulo" value={form.titulo} onChange={(e) => definir("titulo", e.target.value)}
            placeholder="Ex.: X-Bacon Duplo" className="mt-1" data-e2e="impulsionar-campo-titulo" />
          <p className="text-[11px] text-muted-foreground mt-1">Aparece em destaque no Facebook, ao lado do botão. Também vira o nome da campanha.</p>
        </div>
        <div>
          <Label>Botão</Label>
          <div className="mt-1 flex flex-wrap gap-2">
            {(a.dados.botoes || []).map((b) => (
              <button key={b.valor} type="button" onClick={() => definir("botao", b.valor)} data-e2e={`impulsionar-botao-${b.valor}`}
                className={`rounded-lg border px-3 py-1.5 text-sm font-medium ${form.botao === b.valor ? "border-primary bg-primary/10 text-primary" : "hover:border-primary"}`}>
                {b.rotulo}
              </button>
            ))}
          </div>
        </div>
        {a.produto && (
          <button type="button" onClick={a.usarSugestao} data-e2e="impulsionar-sugestao"
            className="inline-flex items-center gap-1.5 text-sm text-primary hover:underline">
            <Sparkles className="w-3.5 h-3.5" /> Usar o texto sugerido para {a.produto.nome}
          </button>
        )}
      </div>
    </Cartao>
  );
}
